export const VOTE_SUBMIT = 'VOTE_SUBMIT';
export const VOTE_SUBMITTED = 'VOTE_SUBMITTED';
export const TEXT_SUBMITTED = 'TEXT_SUBMITTED';
export const HYDRATE_CONFIG = 'HYDRATE_CONFIG';

export const CONTEXT_PATH = '/sparing-min-side-web';
export const SERVICE_PATH = 'rest/resource/tilbakemelding';
export const FULL_PATH = `${CONTEXT_PATH}/${SERVICE_PATH}`;
export const FETCHSIGNAL = {};